import { useState } from "react"
import Input, { clearForm, FormState, required, submitForm, useTextInput } from "../../../../components/input"

export default function CreateAnswers({state, answers, isDraft, answersChanged}) {

    const [selectedAnswer, setSelectedAnswer] = useState(undefined)

    const answerForm = {
        answerMentor: useTextInput("Answer for Mentor", "quickreply", [required]),
        answerMentee: useTextInput("Answer for Mentee", "quickreply", [required])
    }

    const addAnswer = () => {
        let answerInfo = submitForm(answerForm)
        if (!answerInfo) return
        answersChanged(prev => {
            if (!selectedAnswer) return [...prev, answerInfo]
            const idx = prev.indexOf(selectedAnswer)
            if (idx === -1) return [...prev, answerInfo]
            return prev.map((a, i) => (i === idx ? answerInfo : a))
        })
        if (selectedAnswer) setSelectedAnswer(undefined)
        clearForm(answerForm)
    }

    const removeAnswer = (answer) => answersChanged(prev => prev.filter(it => it !== answer))

    const editAnswer = (answer) => {
        setSelectedAnswer(answer)
        answerForm.answerMentor._setValue(answer.answerMentor)
        answerForm.answerMentee._setValue(answer.answerMentee)
    }

    return(
        <div className="showing flex columns gap-xs">
            <p className="card-title vi-spacer-m">Answers</p>
            {answers?.length > 0 && <div className="flex columns gap-xs">
                {answers.map((answer, idx) => <div className={`outline-card card-body flex space-between gap-xs ${selectedAnswer == answer ? 'shaded-primary' : ''}`}>
                    <div className="flex center gap-l">
                        <p className=" bold neutral">{idx + 1}.</p>
                        <div>
                            <div className="flex center gap-s v-spacer-s">
                                <p className="bold card-label-s neutral">FOR MENTOR:</p>
                                <p className="medium card-body">{answer.answerMentor}</p>
                            </div>
                            <div className="flex center gap-s">
                                <p className="bold card-label-s neutral h-spacer-xxs">FOR MENTEE:</p>
                                <p className="medium card-body">{answer.answerMentee}</p>
                            </div>
                        </div>
                    </div>
                    <div className="flex gap-xs center">
                        <button className="icon small" onClick={() => editAnswer(answer)}><span className="material-symbols-outlined">edit</span></button>
                        {(state != FormState.UPDATE || isDraft) && <button className="icon small" onClick={() => removeAnswer(answer)}><span className="material-symbols-outlined">close</span></button>}
                    </div>
                </div>)}
            </div>}
            {(state != FormState.UPDATE || isDraft || selectedAnswer != undefined) && <>
                <Input state={answerForm.answerMentor}/>
                <Input state={answerForm.answerMentee}/>
                <div className="flex justify-end">
                    <button className="solid" onClick={addAnswer}>{selectedAnswer ? 'Save' : 'Add'} Answer</button>
                </div>
            </>}
        </div>
    )
}

export function packAnswers(answers) {
    if (!answers || answers.length  === 0) return undefined
    return {
        answersMentor: answers.map(it => it.answerMentor),
        answersMentee: answers.map(it => it.answerMentee),
    }
}

export function unpackAnswers(question) {
    if (!question?.answersMentor || !question?.answersMentee) return []
    return question.answersMentor.map((mentorAnswer, idx) => ({
        answerMentor: mentorAnswer,
        answerMentee: question.answersMentee?.[idx] ?? mentorAnswer
    }))    
}